import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useGlobalStateContext } from "../../context/globalContext";
import Counter from "./counter";

const CustomCursor = ({}) => {
  const { cursorType } = useGlobalStateContext();
  const [mousePosition, setMousePosition] = useState({ y: 400, x: 400 });
  const [showCounter, setShowCounter] = useState(false);

  const onMouseMove = (event) => {
    const { pageX: x, pageY: y } = event;
    setMousePosition({ x, y });
  };

  useEffect(() => {
    setTimeout(() => {
      setShowCounter(true);
    }, 4000);
    setTimeout(() => {
      setShowCounter(false);
    }, 6500);
    document.addEventListener("mousemove", onMouseMove);
    return () => document.removeEventListener("mousemove", onMouseMove);
  }, []);

  return (
    <div
      id="cursor"
      style={{
        position: "absolute",
        left: `${mousePosition.x}px`,
        top: `${mousePosition.y}px`,
      }}
    >
      <motion.div
        className="arrows"
        initial={{ opacity: 0 }}
        animate={{ opacity: cursorType === "drag" ? 1 : 0 }}
      >
        <div className="arrow left"></div>
        <div className="arrow right"></div>
      </motion.div>

      <svg
        id="cursorSvg"
        // ${!!cursorType ? "hovered" : ""}
        className={`${cursorType}`}
        height="40px"
        width="40px"
      >
        <circle
          cx="20px"
          cy="20px"
          r="18px"
          stroke="white"
          strokeWidth="1"
          fillOpacity="0"
        />
      </svg>
      <Counter show={showCounter} />
    </div>
  );
};

export default CustomCursor;
